import React, { useState } from 'react';

import {
  Container,
  Box,
  Typography,
  Grid,
  Menu,
  MenuItem,
  Button,
} from '@mui/material';
import { useNavigate } from 'react-router';
import PROVIDER_TYPES from './providerTypes';

export default function EmptyProviders() {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const enableProvider = async (type) => {
    handleClose();
    // setLoading(true);
    // await dispatch(createProvider({ type }));

    navigate(`/resources/provider/new?type=${type}`);
  };

  return (
    <Container maxWidth='sm'>
      <Grid container>
        <Grid size={{ xs: 12, md: 12, lg: 12 }}>
          <Box display='flex' flexGrow={1} justifyContent='center'>
            <img
              style={{ width: '150px' }}
              src='/img/gpu-purple-256.png'
              alt='Resources Icon'
            />
          </Box>
        </Grid>
        <Grid size={{ xs: 12, md: 12, lg: 12 }}>
          <Typography variant='h5' paragraph gutterBottom align='center'>
            Welcome to CloudBender&reg; by {import.meta.env.VITE_ORG_NAME}
          </Typography>
          <Typography variant='body1' paragraph align='center'>
            CloudBender lets you connect your on-prem and cloud GPUs to the
            {import.meta.env.VITE_ORG_NAME} platform and seamlessly run jobs
            across them.
          </Typography>
          <Typography variant='body1' paragraph align='center' gutterBottom>
            To get started, enable a cloud or physical resource provider.
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, md: 12, lg: 12 }}>
          <Box display='flex' flexGrow={1} justifyContent='center' mt={2}>
            <Button variant='contained' color='brand' onClick={handleClick}>
              Enable Provider
            </Button>
            <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
              <MenuItem
                onClick={() => enableProvider(PROVIDER_TYPES.PHYSICAL.value)}
              >
                {PROVIDER_TYPES.PHYSICAL.label}
              </MenuItem>
              <MenuItem
                onClick={() => enableProvider(PROVIDER_TYPES.GCP.value)}
              >
                {PROVIDER_TYPES.GCP.label}
              </MenuItem>
              <MenuItem
                onClick={() => enableProvider(PROVIDER_TYPES.AWS.value)}
              >
                {PROVIDER_TYPES.AWS.label}
              </MenuItem>
            </Menu>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
}
